import { isEditorX } from '../../utils/editorx';
export const defaultSettings = {
  apiUrl: isEditorX ? 'https://www.editorx.com' : 'https://www.wix.com',
  itemsLimit: 30 // unsplash only gives 30
};